<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Section</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Section</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="Section">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{ name: 'SectionList' }"
                  ><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="form-group required">
                    <label class="control-label">Course</label>
                    <multiselect
                      id="course_id"
                      name="course_id"
                      :options="Object.keys(pre.course_id)"
                      :custom-label="(opt) => pre.course_id[opt]"
                      v-bind:class="{ 'has-error': errors.has('course_id') }"
                      v-validate="'required'"
                      v-model="value.course_id"
                      class="course_id"
                      placeholder="Select Course"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                    ></multiselect>
                    <div
                      class="help text-danger"
                      v-show="errors.has('course_id')"
                    >
                      {{ errors.first("course_id") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label"
                      >Section / Subject Title (English)</label
                    >
                    <input
                      type="text"
                      id="section_title"
                      name="section_title"
                      v-bind:class="{
                        'has-error': errors.has('section_title'),
                      }"
                      v-validate="'required'"
                      v-model="value.section_title"
                      class="form-control section_title"
                      placeholder="Section / Subject Title (English)"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('section_title')"
                    >
                      {{ errors.first("section_title") }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label"
                      >Section / Subject Title (Bangla)</label
                    >
                    <input
                      type="text"
                      id="section_title_bn"
                      name="section_title_bn"
                      v-bind:class="{
                        'has-error': errors.has('section_title_bn'),
                      }"
                      v-model="value.section_title_bn"
                      class="form-control section_title_bn"
                      placeholder="Section / Subject Title (Bangla)"
                    />
                  </div>
                  <div class="form-group">
                    <label for="description" class="control-label"
                      >Description (English)</label
                    >
                    <textarea
                      name="description"
                      id="description"
                      v-model="value.description"
                      class="form-control"
                      rows="5"
                    ></textarea>
                    <!-- <input
                      type="text"
                      id="description"
                      name="description"
                      v-model="value.description"
                      class="form-control description"
                      placeholder="Description (English)"
                    /> -->
                  </div>
                  <div class="form-group">
                    <label for="description_bn" class="control-label"
                      >Description (Bangla)</label
                    >
                    <textarea
                      name="description_bn"
                      id="description_bn"
                      v-model="value.description_bn"
                      class="form-control description_bn"
                      rows="5"
                    ></textarea>
                    <!-- <input
                      type="text"
                      id="description_bn"
                      name="description_bn"
                      v-model="value.description_bn"
                      class="form-control description_bn"
                      placeholder="Description (Bangla)"
                    /> -->
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Duration (In Minutes)</label>
                    <input
                      type="number"
                      min="0"
                      id="duration"
                      name="duration"
                      v-bind:class="{ 'has-error': errors.has('duration') }"
                      v-validate="'required'"
                      v-model="value.duration"
                      class="form-control duration"
                      placeholder="Duration (In Minutes)"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('duration')"
                    >
                      {{ errors.first("duration") }}
                    </div>
                  </div>
                  <div class="col-md-12">
                    <h4 class="site-heading my-3">
                      <span>Featured Image</span>
                    </h4>
                  </div>
                  <div class="form-group col-md-12">
                    <label for="featured_image"></label>
                    <div class="row align-items-center">
                      <div class="col-4">
                        <div class="input-group">
                          <div class="custom-file">
                            <input
                              type="file"
                              id="featured_image"
                              name="featured_image"
                              class="custom-file-input"
                              accept="image/png, image/jpeg, image/jpg"
                              @change="selectFile($event)"
                            />
                            <label
                              class="custom-file-label"
                              for="featured_image"
                              >Choose file</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="form-group" v-if="fileName">
                        <img
                          alt="preview image"
                          v-if="value.file"
                          :src="value.file"
                          width="100"
                          height="100"
                          class="img-circle"
                        />
                        {{ fileName }}
                        &nbsp;
                        <i class="fas fa-window-close" @click="removeFile"></i>
                      </div>
                    </div>
                    <span class="help text-info xs-text"
                      >Supported mimes: jpeg, jpg, png</span
                    >
                    <br />
                    <div class="help text-danger" v-show="errors.has('file')">
                      {{ errors.first("file") }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Display Order</label>
                    <input
                      type="number"
                      min="0"
                      id="display_order"
                      name="display_order"
                      v-model="value.display_order"
                      class="form-control display_order"
                      placeholder="Display Order"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">
                Submit
              </button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "SectionForm",
  metaInfo: {
    title: "Section | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {
      duration: 0,
      display_order: 999,
      file: null,
    },
    pre: {
      course_id: {},
    },
    fileName: "",
  }),
  methods: {
    selectFile: function (event) {
      this.is_loading = true;
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        this.value.file = reader.result;
        this.fileName = event.target.files[0].name;
        this.is_loading = false;
      };
    },
    removeFile: function (index = 0) {
      this.value.file = null;
      this.fileName = null;
    },
    courseIdOptions: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-dropdown-options/8")
          .then((response) => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },

    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/sections";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/sections/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "SectionList" });
            })
            .catch((errors) => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message);
              }
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/sections/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;
      await this.courseIdOptions().then((course_id) => {
        this.pre.course_id = course_id;
      });

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
            this.value.file =
              this.API_ASSET_UPLOAD_URL +
              "learning/" +
              this.value.featured_image;
            var filename = this.value.featured_image.split("images/");
            this.fileName = filename.length > 0 ? filename[1] : "";
          })
          .catch((error) => {
            console.log(error.response);
          });
      }

      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
};
</script>
